import React, { useState } from 'react';
export default function SelectBox(props) {
    const [open, setOpen] = useState(false);
    const selected = String(props.selected || '');
    const select = item => {
        props.setSelect(item)
    }

    return (
        <div  style={{width:296}} onClick={()=>setOpen(!open)} onBlur={()=>setOpen(false)} className={`select-box d-flex justify-content-between align-items-center ${props.status && 'select-box-disable'} ${open && 'select-box-active'} ${props.className}`} tabIndex={-1}>
            <p className="cap">{selected.toLowerCase().replace('id','')}</p>
            <svg xmlns="http://www.w3.org/2000/svg" width="12.732" height="7.426" viewBox="0 0 12.732 7.426">
                <g id="ArrowDown" transform="translate(-407.939 -377.939)">
                    <path id="Line_19" d="M0 5.305L5.305 0" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1" transform="rotate(-90 396.653 -12.348)"/>
                    <path id="Line_20" d="M0 0L5.305 5.305" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1" transform="rotate(-90 399.305 -15)"/>
                </g>
            </svg>
            {open &&
            <div className="sub-select">
                {props.items.map((value,key)=>(
                    <p className="cap" key={key} onClick={() => select(value)}>{value.toLowerCase().replace('id','')}</p>
                ))}
            </div>}
        </div>
    );
}
